import axios from "axios";
import { getStoredEmail } from "./accountsApi";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";
const API = `${BACKEND_URL}/api/budgets`;

function authHeaders() {
  const email = getStoredEmail();
  return email ? { "X-Account-Email": email } : {};
}

export async function listarPresupuestos() {
  const { data } = await axios.get(API, { headers: authHeaders() });
  return Array.isArray(data) ? data : [];
}

export async function obtenerPresupuesto(id) {
  const { data } = await axios.get(`${API}/${encodeURIComponent(id)}`, {
    headers: authHeaders(),
  });
  return data;
}

export async function crearPresupuesto(payload) {
  const { data } = await axios.post(API, payload, { headers: authHeaders() });
  return data;
}

export async function guardarPresupuesto(id, payload) {
  const { data } = await axios.put(`${API}/${encodeURIComponent(id)}`, payload, {
    headers: authHeaders(),
  });
  return data;
}

export async function eliminarPresupuesto(id) {
  await axios.delete(`${API}/${encodeURIComponent(id)}`, {
    headers: authHeaders(),
  });
}

export async function enviarPresupuestoPorEmail(id, payload) {
  const { data } = await axios.post(
    `${API}/${encodeURIComponent(id)}/send-email`,
    payload,
    { headers: authHeaders() },
  );
  return data;
}

export function nuevoPresupuestoId() {
  const t = Date.now().toString(36).toUpperCase();
  const r = Math.random().toString(36).slice(2, 6).toUpperCase();
  return `B-${t}-${r}`;
}
